<template>
  <form-section>
    <el-row :gutter="30">
      <el-col :span="12">
        <inbox-message-settings-form
          v-if="model.inbox_settings"
          type="ios"
          v-model="model"
        ></inbox-message-settings-form>
      </el-col>

      <el-col :span="12">
        <div class="preview-frame">
          <ios-inbox-preview
            v-if="model.inbox_settings"
            logo-url="/img/powered_by_XP.png"
            :push-notification-switch="model.inbox_settings.switch"
            :position="model.inbox_settings.position"
            :colors="model.inbox_settings.colors"
          />
        </div>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import IosInboxPreview from '@/modules/settings/components/IosInboxPreview'
import InboxMessageSettingsForm from '@/modules/settings/components/InboxMessageSettingsForm'
import FormSection from '@/common/components/form/FormSection'
import { inboxSettingsIos } from '@/modules/settings/enum/IosInboxDefaultSettings'
export default {
  name: 'InboxMessageSettingsIos',
  components: {
    FormSection,
    IosInboxPreview,
    InboxMessageSettingsForm
  },
  props: {
    model: {
      required: true
    }
  },
  mounted() {
    if (this.model.inbox_settings === null) {
      this.model.inbox_settings = { ...inboxSettingsIos }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.preview-frame {
  height: 700px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/InboxMessageSettingsIos.vue